import { useLocation } from "@reach/router"
import { memo } from "react"

import { Icon } from "@trueskin-web/components"
import { arrowRightIcon } from "@trueskin-web/theme/icons/arrowRightIcon"
import { checkIcon } from "@trueskin-web/theme/icons/checkIcon"
import { Routes } from "@trueskin-web/translations"

const steps = [
  {
    label: "Fragebogen",
  },
  {
    label: "Plan",
    locations: [
      Routes.App.Start.InitialTreatmentPlan.url,
      Routes.App.Start.ChoosePlan.url,
    ],
  },
  {
    label: "Daten",
    locations: [Routes.App.Start.Shipping.url],
  },
  {
    label: "Überprüfung",
    locations: [Routes.App.Start.Payment.url],
  },
]

const ProgressStep = ({ label, isCompleted, isActive, isLast }) => (
  <div
    sx={{
      display: "inline-flex",
      alignItems: "center",
      gap: 1,
    }}
  >
    {isCompleted && !isActive && (
      <Icon
        icon={checkIcon}
        size="sm"
        color="neutralsDarkGrey"
        sx={{ mt: "2px", transform: "scale(1.25)" }}
      />
    )}
    <div
      sx={{
        mb: "-1px",
        py: 4,
        fontSize: 0,
        fontWeight: isActive ? "bold" : "normal",
        lineHeight: 1.25,
        color: isActive ? "text" : "neutralsDarkGrey",
        borderBottom: isActive ? "1px solid" : "none",
        borderColor: "text",
      }}
    >
      {label}
    </div>
    {!isLast && (
      <Icon
        icon={arrowRightIcon}
        size="sm"
        color="neutralsMediumGrey"
        sx={{ transform: "scale(1.25)" }}
      />
    )}
  </div>
)

const ProgressBar = ({ stepConditions }) => {
  const location = useLocation()
  const enabledLocations = steps.map(({ locations = [] }) => locations).flat()

  if (!enabledLocations.includes(location.pathname)) {
    return null
  }

  return (
    <div
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        borderTop: "1px",
        borderBottom: "1px",
        borderColor: "grey",
      }}
    >
      {steps.map((step, index) => (
        <ProgressStep
          key={index}
          label={step.label}
          isCompleted={stepConditions[index]?.()}
          isActive={step.locations?.includes(location.pathname)}
          isLast={index >= steps.length - 1}
        />
      ))}
    </div>
  )
}

export default memo(ProgressBar)
